import { render, staticRenderFns } from "./listar-pedidos.vue?vue&type=template&id=1b03ddcc&"
import script from "./listar-pedidos.vue?vue&type=script&lang=js&"
export * from "./listar-pedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports